export default __webpack_public_path__ + "static/map-2535f0274adb19049df77c2d7aee1807.svg";